import React from 'react';
import {connect} from 'react-redux';
import {withTranslation, Trans} from 'react-i18next';
import Popup from '../../../../components/popup/index';
import AddCollaboratorsPopup from './components/add-collaborators-popup';
import ViewCollaboratorsPopup from './components/view-collaborators-popup';
import TransferOwnershipPopupMessage from './components/transfer-ownership-popup-message';
import GetShareableLinkPopupMessage from './components/get-shareable-link-popup-message';
import {
	addToContactSwitch,
	autoCompleteEnteredValue,
	collaboratorsPageNumber,
	getAutoComplete,
	getChangedStatus,
	getSharingDetailsPopup,
	invalidShare, isSharing, notify,
	ownershipChangeTarget,
	resetAddedCollaborators, resetCollaborators, selectedCollaborator,
	updateCollaborators, updatingCollaborators
} from '../../../../../actions/sharingDetailsActions';
import ExpiredEvalPopupMessage from './components/expired-eval-popup-message';
import {isEmailValid, isEmpty} from '../../../../../actions/addCollaboratorActions';
import InvalidSharingPopupMessage from './components/invalid-sharing-popup-message';
import ContactNotFound from './components/contact-not-found'
import ChoosePlan from "./components/choose-plan";
import { APP_URL } from '../../../../utils';
import SelectOneLabelPopup from "./components/select-one-label-popup";
import LabelDeleteConfirmPopup from './components/label-delete-confirm-popup';
import NewLabelPopup from "./components/new-label-popup";
import RenameLabelPopup from "./components/rename-label-popup";
import AddExistingContactToLabelPopup from "./components/add-existing-contact-to-label-popup";
import {
	contactDetailsEditMode,
	enteredModalContactSearchValue,
	resetCommentToAddContactSearchResult,
	resetCommentToEditContactSearchResult,
	resetModalContactSearchResult,
	selectContactToAdd,
	selectLabelToAdd, stopFindingNextMyContacts, targetedContact
} from '../../../../../actions/contactActions';
import ContactDetailsPopup from "./components/contact-details-popup";
import ConfirmSharingPopup from "./components/confirm-sharing-popup";
import FinishFirstLabelSharingPopup from "./components/finish-first-label-sharing-popup";
import EasterEggPopup from "./components/easter-egg-popup";
import LabelCreationLimitPopup from "./components/label-creation-limit-popup";
import InvalidLabelAttachmentPopup from "./components/invalid-label-attachment-popup";
import LabelRenameLimitForInvitedPopup from "./components/label-rename-limit-for-invited-popup";
import DeleteContactPopup from "./components/delete-contact-popup";
import NewContactPopup from "./components/new-contact-popup";
import LabelLoadingErrorPopup from "./components/label-loading-error-popup";
import {isLabelsLoading, labelStateUpdating} from '../../../../../actions/contactsGroupItemActions';
import OverQuotaPopup from "./components/overquota-popup";
import {
    commentContentToAdd,
    commentContentToEdit, editingComment,
    parseContactOnCommentToAdd, parseContactOnCommentToEdit
} from "../../../../../actions/commentActions";
import {addToOtherLabel, resetFindContactDetails} from '../../../../../actions/contactDetailsActions';
import ExpiredPaidPopupMessage from './components/expired-paid-popup-message';
import DirectorySyncPopup from './components/directory-sync-popup';
import ConfirmDirectorySharingPopup from './components/confirm-directory-sharing-popup';
import UserStatusesPopupMessage from "./components/user-statuses-popup-message";

class SharingDetailsPopup extends React.Component {

	constructor(props){
		super(props);

		this.closePopup = this.closePopup.bind(this);
		this.resend = this.resend.bind(this);
	}

	closePopup(){
		this.props.getSharingDetailsPopup([]);

		switch (this.props.sharingDetailsPopup[1]) {

			case 'select_label':
                this.props.setSelectLabelToAdd([]);
                break;

			case 'add_existing_contact_to_label':
				if(this.props.findMyContacts && this.props.findMyContacts.contacts.length < this.props.findMyContacts.pages.totalRecords){
					this.props.stopFindingNextMyContacts(true);
				}
                this.props.setSelectContactToAdd([]);
                this.props.setEnteredModalContactSearchValue('');
                this.props.resetModalContactSearchResult();
                break;

            case 'contact_details':
                this.props.setContactDetailsEditMode(false);
                this.props.setEditingComment(null);
                this.props.resetFindContactDetails();
                this.props.setCommentContentToAdd("");
                this.props.setCommentContentToEdit("");
                this.props.parseContactOnCommentToAdd(null);
                this.props.parseContactOnCommentToEdit(null);
                this.props.resetCommentToAddContactSearchResult();
                this.props.resetCommentToEditContactSearchResult();
	            this.props.setAddToOtherLabel(false);
                break;

            case 'add_user':
                this.props.resetCollaborators();
                this.props.setTargetedContact(null);
				this.props.autoCompleteEnteredValue("");
				this.props.resetAddedCollaborators();
	            if(this.props.addToContactSwitch === false){
		            this.props.setAddToContactSwitch(true);
	            }
                this.props.invalidShare(false);

                if(this.props.isEmpty){
                    this.props.setIsEmpty(false);
                }

                if(this.props.isEmailValid === false){
                    this.props.setIsEmailValid(true);
                }

                if(this.props.collaboratorsPageNumber > 1){
                    this.props.setCollaboratorsPageNumber(1);
				}

				if(this.props.updateCollaborators.length > 0){
					this.props.setUpdateCollaborators([])
				}

                if(this.props.changedStatus){
                    this.props.setChangedStatus(false)
                }

                if(this.props.selectedCollaborator !== null){
                	this.props.setSelectedCollaborator(null);
				}

                if(!this.props.hasSharedLabels){
		            if(document.getElementById("t3")){
			            document.getElementById("t3").style.transform = 'scale(1)';
		            }
	            }

                this.props.setNotify(true);
				this.props.labelStateUpdating(null);
				this.props.setIsSharing(false);
				break;
			case 'confirm_sharing':
			case 'confirm_directory_sharing':
				this.props.autoCompleteEnteredValue("");
				this.props.resetAddedCollaborators();
				this.props.labelStateUpdating(null);
				this.props.setIsSharing(false);
				break;
			case 'transfer_ownership':

                if(this.props.changedStatus){
                    this.props.setChangedStatus(false)
                }

				this.props.setUpdatingCollaborators(false);
				this.props.setUpdateCollaborators([]);
				this.props.labelStateUpdating(null);

                this.props.ownershipChangeTarget(null);

                if(this.props.collaboratorsPageNumber > 1){
                    this.props.setCollaboratorsPageNumber(1)
                }
				break;
            case "labels_loading_error":
                this.props.setIsLabelsLoading(false);
                break;
			default:
				break;
		}
	}

	resend(){
		window.open('https://mail.google.com/mail/u/0/?view=cm&fs=1&to=' + this.props.sharingDetailsPopup[3] + '&su=' + this.props.profile.name + ' shared contacts with you' +
			'&body=Hello,%0A%0AI am sharing my group of contacts called ' + this.props.selectedContactsGroup.name + ' with you.%0A%0A' +
			'To accept the invitation, please click on this link: ' + window.location.origin + '/invited' +
			'%0A%0A--%0ABest regards,%0A'+
			this.props.profile.name +'&tf=1',
			'Send email',
			'_blank,width=990,height=600');
	}

	contentPopup(){
		switch (this.props.sharingDetailsPopup[1]) {
            case "new_label":
                return <NewLabelPopup/>;
            case 'gmail_add_on_new_label':
                return <NewLabelPopup />;
            case "rename_label":
                return <RenameLabelPopup/>;
            case 'gmail_add_on_rename_label':
                return <RenameLabelPopup />;
            case "select_one_label":
                return <SelectOneLabelPopup/>;
            case 'gmail_select_one_label':
                return <SelectOneLabelPopup />;
            case "label_creation_limit":
                return <LabelCreationLimitPopup/>;
            case "label_creation_limit_for_invited":
                return <LabelCreationLimitPopup invited={true}/>;
            case "label_rename_limit_for_invited":
                return <LabelRenameLimitForInvitedPopup/>;
            case "contact_not_found":
                return <ContactNotFound/>;
            case "label_delete_confirm":
                return <LabelDeleteConfirmPopup/>;
            case "labels_loading_error":
                return <LabelLoadingErrorPopup/>;
			case "add_existing_contact_to_label":
                return <AddExistingContactToLabelPopup/>;
			case "contact_details":
                return <ContactDetailsPopup/>;
            case "gmail_contact_details":
                    return <ContactDetailsPopup/>;
			case "add_user":
				return <AddCollaboratorsPopup/>;
            case 'gmail_add_user':
                return <AddCollaboratorsPopup />;
            case "view_collaborators":
                return <ViewCollaboratorsPopup/>;
            case "confirm_sharing":
                return <ConfirmSharingPopup/>;
			case "confirm_directory_sharing":
				return <ConfirmDirectorySharingPopup/>;
			case "finish_first_label_sharing":
                return <FinishFirstLabelSharingPopup/>;
            case 'gmail_finish_first_label_sharing':
                return <FinishFirstLabelSharingPopup />;
                case "choose_plan":
                return <ChoosePlan/>;
            case "transfer_ownership":
                return <TransferOwnershipPopupMessage getBack={this.closePopup}/>;
			case "expired_eval":
				return <ExpiredEvalPopupMessage getBack={this.closePopup}/>;
			case "expired_paid":
				return <ExpiredPaidPopupMessage getBack={this.closePopup}/>;
            case "get_shareable_link":
                return <GetShareableLinkPopupMessage enabled={this.props.profile.domain.plan === "BUSINESS" || this.props.profile.domain.plan === "ENTERPRISE" || this.props.profile.domain.status === "EVAL"} />;
			case "easter_egg":
                return <EasterEggPopup/>;
            case "gmail_new_contact":
                return <NewContactPopup/>;
            case "new_contact":
                return <NewContactPopup/>;
            case "delete_contact":
                return <DeleteContactPopup/>;
			case "CONTACT_GROUP_250PLUS":
                return <InvalidLabelAttachmentPopup error="CONTACT_GROUP_250PLUS" close={this.closePopup}/>;
            case "INVALID_STATUS_FOR_ATTACHMENT":
                return <InvalidLabelAttachmentPopup error="INVALID_STATUS_FOR_ATTACHMENT" close={this.closePopup}/>;
			case "BASIC_USER_LIMIT":
				return <InvalidSharingPopupMessage error="BASIC_USER_LIMIT" close={this.closePopup} />;
            case "LITE_USER_LIMIT":
                return <InvalidSharingPopupMessage error="LITE_USER_LIMIT" close={this.closePopup} />;
			case "BASIC_GROUP_LIMIT":
				return <InvalidSharingPopupMessage error="BASIC_GROUP_LIMIT" close={this.closePopup} resend={this.resend}/>;
            case "LITE_GROUP_LIMIT":
                return <InvalidSharingPopupMessage error="LITE_GROUP_LIMIT" close={this.closePopup} resend={this.resend}/>;
			case "BASIC_DOMAIN_GROUP_LIMIT":
				return <InvalidSharingPopupMessage error="BASIC_DOMAIN_GROUP_LIMIT" close={this.closePopup} />;
            case "LITE_DOMAIN_GROUP_LIMIT":
                return <InvalidSharingPopupMessage error="LITE_DOMAIN_GROUP_LIMIT" close={this.closePopup} />;
			case "PRO_DOMAIN_GROUP_LIMIT":
				return <InvalidSharingPopupMessage error="PRO_DOMAIN_GROUP_LIMIT" close={this.closePopup} />;
            case "EXTERNAL_USER_LIMIT":
                return <InvalidSharingPopupMessage error="EXTERNAL_USER_LIMIT" close={this.closePopup} />;
            case "LITE_EXTERNAL_USER_LIMIT":
            	return <InvalidSharingPopupMessage error="LITE_EXTERNAL_USER_LIMIT" close={this.closePopup} />;
            case "TEAM_EXTERNAL_USER_LIMIT":
                return <InvalidSharingPopupMessage error="TEAM_EXTERNAL_USER_LIMIT" close={this.closePopup} />;
            case "TEAM_DOMAIN_GROUP_LIMIT":
                return <InvalidSharingPopupMessage error="TEAM_DOMAIN_GROUP_LIMIT" close={this.closePopup} />;
			case "LICENSES_LIMIT":
				return <InvalidSharingPopupMessage error="LICENSES_LIMIT" close={this.closePopup} />;
			case "SELF_SHARING_NOT_ALLOWED":
				return <InvalidSharingPopupMessage error="SELF_SHARING_NOT_ALLOWED" close={this.closePopup} />;
            case "INTERNAL_USER_INVITED":
                return <InvalidSharingPopupMessage error="INTERNAL_USER_INVITED" close={this.closePopup} />;
            case "EXTERNAL_USER_INVITED":
                return <InvalidSharingPopupMessage error="EXTERNAL_USER_INVITED" close={this.closePopup} />;
            case "NOT_FOUND":
                return <InvalidSharingPopupMessage error="NOT_FOUND" close={this.closePopup} />;
            case "INVALID_PAYMENT_STATUS":
                return <InvalidSharingPopupMessage error="INVALID_PAYMENT_STATUS" close={this.closePopup} />;
			case "READ_ONLY_GROUP":
				return <InvalidSharingPopupMessage error="READ_ONLY_GROUP" close={this.closePopup} />;
			case "GROUP_NOT_FOUND":
				return <InvalidSharingPopupMessage error="GROUP_NOT_FOUND" close={this.closePopup} />;
			case "PERMISSION_DENIED":
				return <InvalidSharingPopupMessage error="PERMISSION_DENIED" close={this.closePopup} />;
			case "ACTION_RESTRICTED_DIRECTORY_NOT_SHARED":
				return <InvalidSharingPopupMessage error="ACTION_RESTRICTED_DIRECTORY_NOT_SHARED" close={this.closePopup} />;
			case "ENABLE_DIRECTORY_SYNC":
				return <InvalidSharingPopupMessage error="ENABLE_DIRECTORY_SYNC" close={this.closePopup} />;
			case "ASK_ADMIN_TO_ENABLE_DIRECTORY_SYNC_AND_SHARE_DIRECTORY_LABEL":
				return <InvalidSharingPopupMessage error="ASK_ADMIN_TO_ENABLE_DIRECTORY_SYNC_AND_SHARE_DIRECTORY_LABEL" close={this.closePopup} />;
			case "ASK_ADMIN_TO_SHARE_DIRECTORY_LABEL":
				return <InvalidSharingPopupMessage error="ASK_ADMIN_TO_SHARE_DIRECTORY_LABEL" close={this.closePopup} />;
			case "SHARING_LIMIT_EXCEEDED":
				return <InvalidSharingPopupMessage error="SHARING_LIMIT_EXCEEDED" close={this.closePopup} />;
			case "SHARING_LIMIT_EXCEEDED_BY_FREEMIUM":
				return <InvalidSharingPopupMessage error="SHARING_LIMIT_EXCEEDED_BY_FREEMIUM" close={this.closePopup} />;
			case "NO_OF_CONTACT_LIMIT_EXCEEDED_BY_FREEMIUM":
				return <InvalidSharingPopupMessage error="NO_OF_CONTACT_LIMIT_EXCEEDED_BY_FREEMIUM" close={this.closePopup} />;
			case "DOMAIN_GROUP_SHARING_NOT_ALLOWED_BY_FREEMIUM":
				return <InvalidSharingPopupMessage error="DOMAIN_GROUP_SHARING_NOT_ALLOWED_BY_FREEMIUM" close={this.closePopup} />;
            case 'overQuota':
                return <OverQuotaPopup/>;
			case 'directorySync':
				return <DirectorySyncPopup/>;
			case "user_collaboratorStatuses":
				return <UserStatusesPopupMessage/>;
			default:
				return (
					<div className="p-4">
						<h2>{this.props.t('textUnkownError')}</h2>
						<p><Trans i18nKey="textInvalidStatusForAttachment"
						          components={{a: <a href={`${APP_URL}/support`}> </a>}}/></p>
					</div>
				);
        }
	}

	render(){
		if(this.props.sharingDetailsPopup[0] === true) {
			return (
				<Popup
					unclosable={
						this.props.sharingDetailsPopup[1] === "gmail_contact_details"
						|| this.props.sharingDetailsPopup[1] === "gmail_select_one_label"
						|| this.props.sharingDetailsPopup[1] === "gmail_add_user"
						|| this.props.sharingDetailsPopup[1] === "gmail_new_contact"
					}
                    onClose={this.closePopup}
                    className={`sharing-popup${this.props.sharingDetailsPopup[1] === 'new_label' || this.props.sharingDetailsPopup[1] === "rename_label"  ? ' sm-popup' : ''}
                    ${
                    	this.props.sharingDetailsPopup[1] === "add_user"
                        || this.props.sharingDetailsPopup[1] === "gmail_add_user"
		                ?
		                    ' popup-flex'
		                :
		                    ''
                    }
                    ${
                    	this.props.sharingDetailsPopup[1] === "gmail_contact_details"
	                    || this.props.sharingDetailsPopup[1] === "gmail_select_one_label"
	                    || this.props.sharingDetailsPopup[1] === "gmail_add_user"
	                    || this.props.sharingDetailsPopup[1] === "gmail_new_contact"
		                ?
		                    ' popup-responsive'
		                :
		                    ''
                    }
                `}>
					{this.contentPopup()}
				</Popup>
			)
		} else {
			return "";
		}
	}
}

const mapStateToProps = (state) => {
	return {
        findLabels: state.contactsGroupItemReducer.findLabels,
		findMyContacts: state.contactReducer.findMyContacts,
		autoComplete : state.sharingDetailsReducer.getAutoComplete,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		isEmpty: state.addCollaboratorDetailsReducer.isEmpty,
		isEmailValid: state.addCollaboratorDetailsReducer.isEmailValid,
        profile : state.profileReducer.getProfile,
        collaboratorsPageNumber: state.sharingDetailsReducer.collaboratorsPageNumber,
        changedStatus: state.sharingDetailsReducer.getChangedStatus,
        selectedCollaborator: state.sharingDetailsReducer.selectedCollaborator,
		addToContactSwitch: state.sharingDetailsReducer.addToContactSwitch,
		hasSharedLabels: state.contactsGroupItemReducer.hasSharedLabels,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
        setTargetedContact : (object) => {
            dispatch(targetedContact(object))
        },
        setSelectLabelToAdd : (array) => {
            dispatch(selectLabelToAdd(array))
        },
        setSelectContactToAdd : (array) => {
            dispatch(selectContactToAdd(array))
        },
        getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array))
		},
		getAutoComplete: (string) => {
			dispatch(getAutoComplete(string))
		},
		autoCompleteEnteredValue: (string) => {
			dispatch(autoCompleteEnteredValue(string))
		},
        resetAddedCollaborators: () => {
            dispatch(resetAddedCollaborators())
		},
        setAddToContactSwitch: (boolean) => {
            dispatch(addToContactSwitch(boolean))
        },
		invalidShare: (boolean) => {
			dispatch(invalidShare(boolean))
		},
		ownershipChangeTarget: (boolean) => {
			dispatch(ownershipChangeTarget(boolean))
		},
		setIsEmpty : (boolean) => {
			dispatch(isEmpty(boolean))
		},
		setIsEmailValid : (boolean) => {
			dispatch(isEmailValid(boolean))
		},
        setCollaboratorsPageNumber : (int) => {
            dispatch(collaboratorsPageNumber(int))
        },
		setUpdatingCollaborators : (boolean) => {
			dispatch(updatingCollaborators(boolean))
		},
		setUpdateCollaborators : (array) => {
        	dispatch(updateCollaborators(array))
		},
        setChangedStatus : (boolean) => {
        	dispatch(getChangedStatus(boolean))
		},
        setEnteredModalContactSearchValue: (string) => {
            dispatch(enteredModalContactSearchValue(string))
        },
        resetModalContactSearchResult: (string) => {
            dispatch(resetModalContactSearchResult(string))
        },
		labelStateUpdating : (string) => {
			dispatch(labelStateUpdating(string))
		},
		setSelectedCollaborator : (object) => {
            dispatch(selectedCollaborator(object))
        },
        setContactDetailsEditMode: (boolean) => {
            dispatch(contactDetailsEditMode(boolean))
        },
        resetFindContactDetails: () => {
            dispatch(resetFindContactDetails())
        },
        setIsLabelsLoading: (boolean) => {
            dispatch(isLabelsLoading(boolean))
        },
        setNotify: (boolean) => {
            dispatch(notify(boolean))
        },
        setCommentContentToAdd: (string) => {
            dispatch(commentContentToAdd(string))
        },
        setCommentContentToEdit: (string) => {
            dispatch(commentContentToEdit(string))
        },
        parseContactOnCommentToAdd: (array) => {
            dispatch(parseContactOnCommentToAdd(array))
        },
        parseContactOnCommentToEdit: (array) => {
            dispatch(parseContactOnCommentToEdit(array))
        },
        resetCommentToAddContactSearchResult: () => {
            dispatch(resetCommentToAddContactSearchResult())
        },
        resetCommentToEditContactSearchResult: () => {
            dispatch(resetCommentToEditContactSearchResult())
        },
		setAddToOtherLabel: (boolean) => {
        	dispatch(addToOtherLabel(boolean))
        },
        setEditingComment: (string) => {
            dispatch(editingComment(string))
        },
		stopFindingNextMyContacts: (boolean) => {
			dispatch(stopFindingNextMyContacts(boolean))
		},
		resetCollaborators: () => {
			dispatch(resetCollaborators())
		},
		setIsSharing: (boolean) => {
			dispatch(isSharing(boolean))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SharingDetailsPopup));
